var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleTrendsScraper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".white{fill:#fff;}.google{fill:url(#google-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "google-gradient",
    x1: 4.44048,
    y1: 0.88619,
    x2: 81.05694,
    y2: 83.47983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aaceff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36069,
    stopColor: "#5998f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48883,
    stopColor: "#3c85f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3369cb"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "google",
    d: "M78.17747,88.61091c-18.78499,2.12302-37.56996,2.12302-56.35494,0-5.49081-.62055-9.8129-4.94264-10.43345-10.43345-2.12301-18.78497-2.12301-37.56995,0-56.35493.62055-5.49081,4.94265-9.8129,10.43346-10.43345,18.78498-2.12301,37.56995-2.12301,56.35494,0,5.49081.62055,9.8129,4.94264,10.43346,10.43345,2.12301,18.78497,2.12301,37.56995,0,56.35492-.62055,5.49081-4.94265,9.8129-10.43345,10.43345Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "white",
    d: "M60.95831,39.87389c-1.25712-.89222-3.00071.04541-3.00071,1.58697v2.83827c0,2.07805-1.51922,3.93381-3.58788,4.13115-2.37307.22637-4.36971-1.63367-4.36971-3.96005v-15.70595c0-1.71148-2.0741-2.56564-3.28299-1.35413-9.42371,9.44404-16.03959,19.07711-15.6546,28.72739.31326,7.85225,5.25479,14.33052,12.16258,16.92654.47603.1789.85337-.40738.50527-.77811-1.42057-1.5129-2.29217-3.54555-2.29217-5.78527,0-4.68042,8.47457-13.73409,8.47457-13.73409,0,0,8.47462,9.05366,8.47462,13.73409,0,2.26835-.89365,4.3249-2.34635,5.84388-.34879.36471.01802.95608.49175.78214,7.24832-2.66136,12.42085-9.62064,12.42085-17.79185,0-6.38388-3.15775-12.02763-7.99523-15.46097Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleTrendsScraper);
export default __webpack_public_path__ + "static/media/google-trends-scraper.62ea4fb7041d9816ea34377d5718e3d6.svg";
export { ForwardRef as ReactComponent };